export const sendToDataLayer = (obj) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);
};

export const sendFormInteraction = (formId, fieldName) => {
  sendToDataLayer({
    event: 'form interaction',
    'form title': `hearing aid check ${formId}`,
    'form field': fieldName,
  });
};

export const sendFormSubmitSuccess = (formId) => {
  sendToDataLayer({
    event: 'form submit',
    'form title': `hearing aid check ${formId}`,
  });
};

export const sendFormSubmitValidationError = (
  formId,
  validationResult = [],
) => {
  sendToDataLayer({
    event: 'form submit error',
    'form title': `hearing aid check ${formId}`,
    'form field': validationResult.toString(),
  });
};
